<template>
  <div class="BlockList" v-show="bfloag">
    <div class="BlockList-W">
      <img
        class="imgs"
        src="../../../assets/pc/Login/close.png"
        @click="close"
      />
      <div class="resume-list">
        <div class="pool_main">
          <div class="tags">
            <div class="indexList">
              <div class="Block_list">
                <ul class="block_list_Top">
                  <li>USDT Lock Transaction Hash</li>
                  <li>DO Lock Transaction Hash</li>

                  <li>Amount of PRL-X received</li>
                  <li>Status</li>
                </ul>
              </div>
              <div class="Block_List_center notranslate">
                <ul>
                  <li v-for="(item, index) in list" :key="index">
                    <p>
                      {{ item.coinTxHash }}
                      <img
                        src="../../../assets/pc/Login/copy.png"
                        v-clipboard:copy="item.coinTxHash1"
                        v-clipboard:success="copyClicked"
                        v-clipboard:error="onError"
                      />
                    </p>
                    <p>{{ item.txHash }}</p>
                    <p>{{ item.awardAmount }}</p>
                    <p :class="item.status == 'success' ? 'status' : 'status1'">
                      {{ item.status }}
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="block">
          <el-pagination
            background
            small
            :current-page.sync="pageNum"
            :page-size="10"
            :pager-count="5"
            layout="prev, pager, next"
            @current-change="handleCurrentChange"
            :total="total"
          >
          </el-pagination>
        </div> -->
      </div>

      <!-- <div class="blockbox">
        <div class="blockhead">
          <div>USDT Lock Transaction Hash</div>
          <div>DO Lock Transaction Hash</div>
          <div>Amount of XPRL received</div>
          <div>Status</div>
        </div>
        <div class="blockcont">
          <div class="blockli">
            <div class="blockhash">
              <div>0x1KNk...xk5Ey7</div>
              <img src="../../../assets/pc/Login/copy.png" />
            </div>
            <div>0x1KNk...xk5Ey7</div>
            <div>100</div>
            <div>Success</div>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import { login } from "@/assets/server/api";
import { getSubStr, goPAGE } from "@/utils/utils";
export default {
  props: ["bflog", "rflog", "relist", "total"],
  data() {
    return {
      radioDisabled: false,
      formReadOnly: false,
      bfloag: false,
      list: [],
      total1: null,
      form: {
        email: "",
        do: "",
        code: "",
        resource: "",
      },
      rules: {
        email: [
          {
            required: true,
            message: "email  is required",
            trigger: "change",
          },
          {
            type: "email",
            message: "Please enter a valid email address",
            trigger: ["blur", "change"],
          },
        ],
      },
    };
  },
  components: {},
  created() {},
  mounted() {},
  watch: {
    deep: true,
    bflog(val) {
      this.bfloag = val;
    },
    rflog(val) {
      this.bfloag = val;
    },
    relist(val) {
      this.list = val;
    //  console.log(this.list);
      for (var i = 0; i < this.list.length; i++) {
        this.list[i].coinTxHash1 = this.list[i].coinTxHash;
        this.list[i].coinTxHash = getSubStr(this.list[i].coinTxHash, 0, 5);
        this.list[i].txHash = getSubStr(this.list[i].txHash, 0, 5);
      }
    },
    total(val) {
      this.total1 = val;
    },
  },
  methods: {
    copyClicked(e) {
      this.$message.success({
        type: "info",
        message: "Content copied to clipboard!",
        center: true,
        duration: "500",
      });
    },
    onError(e) {
      this.$message.error("Sorry, copy failed！");
    },
    close() {
      this.bfloag = false;
      this.$emit("bloflog", this.bfloag);
    },
  },
};
</script>
<style lang="less">
/deep/.el-message {
  z-index: 99999999999 !important;
  background-color: #fff !important;
  /* 设置文本颜色为白色 */
  color: white !important;

  /* 其他样式调整，根据需要自行添加 */
}
</style>
<style lang="less" scoped>
.BlockList {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99999999999999;
  // background: red;
  width: 100%;
  height: 100%;
  overflow: auto;
  .BlockList-W {
    width: 678px;
    overflow: hidden;
    background: #202020;
    border-radius: 10px 10px 10px 10px;
    opacity: 1;
    position: absolute;
    z-index: 0 !important;
    // border: 1px solid red;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    .imgs {
      width: 36px;
      height: 36px;
      margin-left: 618px;
      margin-top: 20px;
    }
    //轮播图片开始
    .resume-list {
      width: 702px;
      background: #202020;
      border-radius: 0 0 24px 24px;
      margin: 0 auto;
      margin-top: 30px;
      .pool_main {
        width: 100%;
      }
      .tags {
        display: flex;
        overflow: auto;
        white-space: nowrap;
      }
      //隐藏滚动条
      .tags::-webkit-scrollbar {
        display: none;
      }
      // 列表开始
      .indexList {
        width: 100%;
        margin: 0;
        padding: 0;
        min-height: 300px;
        background: #202020;
        .Block_list {
          .block_list_Top {
            display: flex;
            width: 1800px;
            height: 82px;
            line-height: 82px;
            background: #202020;
            border-radius: 10px 10px 10px 10px;
            opacity: 1;
            li {
              font-size: 28px;
              font-family: PingFang SC-Medium, PingFang SC;
              font-weight: 500;
              color: #8a8a8a;
              height: 82px;
              line-height: 82px;
              -webkit-background-clip: text;
              // flex: 0 0 14%;
              text-align: left;
            }
            li:nth-child(1) {
              margin-left: 40px;
              width: 500px;
            }
            li:nth-child(2) {
              width: 500px;
            }
            li:nth-child(3) {
              width: 500px;
            }
            li:nth-child(4) {
              width: 300px;
              text-align: center;
            }

            // li:nth-child(7) {
            //   width: 200px;
            // }
          }
        }
        .Block_List_center {
          width: 1800px;
          background: #202020;
          
          ul {
            //  height: 620px;
            width: 1800px;
            margin: 0;
            padding: 0;
            //padding: 0 19px;
            li {
              display: flex;
              height: 82px;
              border-bottom: 1px solid #5b5b5b;
              line-height: 82px;
              margin-left: 24px;
              // width: 200px;
              p {
                font-size: 26px;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: #ffffff;
                text-align: left;
                // flex: 0 0 14%;
              }
            }
            li:last-child {
              border-bottom: none;
            }
            p:nth-child(1) {
              width: 500px;
              padding-left: 20px;
              // margin-left: 40px;
              // border: 1px solid red;
              img {
                width: 32px;
                height: 32px;
                margin-top: 22px;
                margin-left: 4px;
              }
            }
            p:nth-child(2) {
              width: 500px;
              color: #8a8a8a;
              img {
                width: 30px;
                height: 30px;
                margin-top: 24px;
                margin-right: 10px;
              }
            }
            p:nth-child(3) {
              width: 500px;
              color: #8a8a8a;
            }
            p:nth-child(4) {
              width: 300px;
              text-align: center;
            }
            .status {
              color: #3cf6f0;
            }
            .status1 {
              color: #f6cb3c;
            }

            // p:nth-child(6) {
            //   width: 400px;
            //   margin-right: 4px;
            //   img {
            //     width: 30px;
            //     height: 30px;
            //     margin-top: 24px;
            //     margin-right: 10px;
            //   }
            // }
            // p:nth-child(7) {
            //   width: 200px;
            // }
          }
        }
      }
      .block {
        margin-top: 70px;
        padding-bottom: 70px;
        font-size: 28px;
        font-family: "PingFang SC-中黑体, PingFang SC";
        font-weight: normal;
        color: #adb0c7;
        // line-height: 39px;
      }
    }
    // .blockbox {
    //   margin-top: 10px;
    //   width: 678px;
    //   overflow: auto;

    //   .blockhead {
    //     display: flex;
    //     font-family: Poppins, Poppins;
    //     font-weight: 400;
    //     font-size: 18px;
    //     color: rgba(255, 255, 255, 0.6);
    //     div:nth-child(1) {
    //       width: 30%;
    //       text-align: left;
    //     }
    //     div:nth-child(2) {
    //       width: 30%;
    //       text-align: left;
    //     }
    //     div:nth-child(3) {
    //       width: 30%;
    //       text-align: left;
    //     }
    //     div:nth-child(4) {
    //       width: 10%;
    //     }
    //   }
    //   .blockcont {
    //     .blockli {
    //       display: flex;
    //       height: 36px;
    //       line-height: 36px;
    //       border-bottom: 1px solid #5B5B5B;
    //       padding-bottom: 4px;
    //       .blockhash {
    //         width: 30%;
    //         display: flex;

    //         div {
    //           width: 130px;
    //           font-family: Poppins, Poppins;
    //           font-weight: 400;
    //           font-size: 16px;
    //           color: #ffffff;
    //         }
    //         img {
    //           width: 21px;
    //           height: 21px;
    //           margin-top: 4px;
    //         }
    //       }
    //       div:nth-child(2) {
    //         width: 30%;
    //         text-align: left;
    //         font-family: Poppins, Poppins;
    //         font-weight: 400;
    //         font-size: 16px;
    //         color: #ffffff;
    //       }
    //       div:nth-child(3) {
    //         width: 30%;
    //         text-align: left;
    //         font-family: Poppins, Poppins;
    //         font-weight: 400;
    //         font-size: 16px;
    //         color: #ffffff;
    //       }
    //       div:nth-child(4) {
    //         width: 10%;
    //         font-family: Poppins, Poppins;
    //         font-weight: 400;
    //         font-size: 16px;
    //         color: #3cf6f0;
    //       }
    //     }
    //   }
    // }
  }
}
</style>
